/**
 * orga app | api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface ReadModelUpdatedNotification { 
    notification_type?: string;
    entity_id?: string;
    entity_type?: string;
    entity_part?: string;
    entity?: string;
    method?: string;
    reason?: string;
    tags?: Array<string>;
}

